var giphy_viewer_default = {
  "giphyWrapper": "ShCWT",
  "giphy_player": "_2UBxJ",
  "playIcon": "_64zJu",
  "gifRatio": "O98QV"
};
export {
  giphy_viewer_default as default
};
//# sourceMappingURL=giphy-viewer-scss.js.map
